import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import apiClient from "api-client";

import KEYS from "../keys";

export const useEmailTemplatesQuery = getWrappedUseQuery(KEYS.GET_EMAIL_TEMPLATES, apiClient.Email.templates.getAll);

export const useEmailByIdQuery = getWrappedUseQuery(KEYS.GET_EMAIL_TEMPLATE_BY_ID, apiClient.Email.templates.get);
